export const CLEAR_CANVAS = 'CLEAR_CANVAS';

export const SET_MODEL = 'SET_MODEL';